import { type NavigationItem } from '@models/Navigation';

const searchInItems = (
    items: NavigationItem[],
    path: string,
): NavigationItem | undefined => {
    const directMatch = items.find((child) =>
        child.exact ? child.to === path : path.startsWith(child.to),
    );
    if (directMatch) return directMatch;

    for (const child of items) {
        if (child.subMenu?.items.length) {
            const nestedMatch = searchInItems(child.subMenu.items, path);
            if (nestedMatch) return nestedMatch;
        }
    }

    return undefined;
};

export function findActiveChildren(
    item: NavigationItem,
    location: string,
): boolean {
    return item.subMenu?.items
        ? Boolean(searchInItems(item.subMenu.items, location))
        : false;
}

export const shouldBeOpen = (
    item: NavigationItem,
    location: string,
): boolean => {
    if (item.to === location) {
        return true;
    }

    const hasChildren = Boolean(item.subMenu?.items.length);
    const isDashboardRoute = /^\/projects\/[a-zA-Z0-9]+$/.test(item.to);

    return (
        (hasChildren && isDashboardRoute) || findActiveChildren(item, location)
    );
};
